module.exports = __webpack_public_path__ + "static/media/ri-check-double-line.005e1bb6.svg";